<template>
  <ui-overlay-loader :loading="complianceReviewListLoading">
    <ui-card class="card-with-margin header-card">
      <ui-heading class="review-header" tag="h4">
        {{ $t("compliance_reviews.search.compliance_reviews") }}
      </ui-heading>
    </ui-card>
    <ui-card class="card-with-margin table-container">
      <compliance-review-filter
        :complianceReviewListLoading="complianceReviewListLoading"
        :handleGetComplianceReviewList="getComplianceReviewList"
      />
      <table class="compliance-review-table">
        <tr class="table-header-row">
          <th>
            {{ $t("compliance_reviews.search.submissionDate") }}
          </th>
          <th>
            {{ $t("compliance_reviews.search.completionDate") }}
          </th>
          <th>
            {{ $t("compliance_reviews.search.company") }}
          </th>
          <th>{{ $t("compliance_reviews.search.project") }}</th>
          <th>
            {{ $t("compliance_reviews.search.identId") }}
          </th>
          <th>{{ $t("compliance_reviews.search.status") }}</th>
          <th>{{ $t("compliance_reviews.search.resolvedBy") }}</th>
          <th>{{ $t("compliance_reviews.search.view") }}</th>
        </tr>
        <tr v-for="(item, key) in complianceReviewList" :key="key">
          <td class="center-aligned-col">
            {{ getDateFormatted(item.createdUtc) }}
          </td>
          <td class="center-aligned-col">
            {{ getDateFormatted(item.completedUtc) }}
          </td>
          <td>
            {{ item.accountName || "-" }}
          </td>
          <td>
            {{ item.subaccountName || "-" }}
          </td>
          <td
            class="left-aligned-col id-value-col"
            @click="handleCopyKycIdentificationId(item.kycIdentificationId)"
          >
            {{ item.kycIdentificationId || "-" }}
          </td>
          <td class="center-aligned-col">{{ item.status }}</td>
          <td>
            {{ item.resolvedByUserEmail || "-" }}
          </td>
          <td class="center-aligned-col">
            <ui-button
              variant="primary"
              @click="openComplianceReview(item.id, item.kycIdentificationId)"
            >
              {{ $t("compliance_reviews.search.view") }}
            </ui-button>
          </td>
        </tr>
      </table>
    </ui-card>
  </ui-overlay-loader>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { actions, getters } from "@/store";
import { ROUTE_NAMES } from "@/router/constants";
import { documentDateFormat } from "@/utils/date";
import ComplianceReviewFilter from "@/components/ComplianceReviewFilter";

export default {
  components: { ComplianceReviewFilter },
  computed: {
    ...mapGetters([
      getters.complianceReviewList,
      getters.complianceReviewListLoading
    ])
  },
  methods: {
    ...mapActions([actions.getComplianceReviewList, actions.notificationAdd]),

    async openComplianceReview(complianceReviewId, identificationId) {
      await this.$router.push({
        name: ROUTE_NAMES.COMPLIANCE_REVIEW_DETAILS,
        query: {
          id: complianceReviewId,
          identificationId: identificationId
        }
      });
    },

    handleCopyKycIdentificationId(id) {
      if (!navigator?.clipboard) {
        return;
      }

      this.notificationAdd({
        id: `kycIdentificationId-clipboard-copy`,
        title: this.$t("compliance_reviews.search.copy_notification.title"),
        message: this.$t(
          "compliance_reviews.search.copy_notification.description",
          { id }
        )
      });

      navigator.clipboard.writeText(id);
    },

    getDateFormatted(dateUtc) {
      return dateUtc ? documentDateFormat(new Date(dateUtc)) : "-";
    }
  }
};
</script>
<style scoped>
.card-with-margin {
  margin: 1rem;
}

.header-card {
  width: fit-content;
}

.header-card .review-header {
  width: fit-content;
  margin: 0;
}

.table-container {
  overflow-x: scroll;
}

.compliance-review-table {
  width: 100%;
}

.table-header-row {
  background-color: var(--table-heading-color);
}

th {
  text-align: center;
}

td,
th {
  min-width: 6rem;
  padding: 0.5rem;
}

th.left-aligned-col {
  text-align: left;
}

td.center-aligned-col {
  text-align: center;
}

.id-value-col {
  max-width: 8rem;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}
</style>
